module["exports"] = {
  "descriptor": [
    "Ведущий",
    "Генеральный",
    "Главный",
    "Глобальный",
    "Международный",
    "Национальный",
    "Областной",
    "Районный",
    "Региональный",
    "Центральный"
  ],
  "level": [
    "интеграционный",
    "логистический",
    "маркетинговый",
    "оптимизационный",
    "страховой",
    "функциональный",
    "коммуникационный",
    "операционный"
  ],
  "job": [
    "агент",
    "администратор",
    "аналитик",
    "архитектор",
    "дизайнер",
    "инженер",
    "консультант",
    "координатор",
    "менеджер",
    "планировщик",
    "помощник",
    "разработчик",
    "руководитель",
    "сотрудник",
    "специалист",
    "техник"
  ]
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ru/name/title.js
// module id = 3511
// module chunks = 1610